<div class="quote-container" style="margin-top: -78px;" >
  <div class="title">{{'Quotes' | translate | async}}</div>
  <ul class="select-quote-container">
    <li class="select-quote" *ngFor="let quote of quotes; let i = index" [class.active]="quote.QuoteId == selectedQuoteId" (click)="setSelectedQuoteId(quote.QuoteId)">{{i + 1}}</li>
    <li *ngIf="isInterpreter" class="select-quote add-quote" (click)="addQuote()" [matTooltip]="'Create New Quote' | translate | async">
      <i *ngIf="!addingQuote" class="material-icons add-quote__icon">add</i>
      <mat-spinner diameter="19" *ngIf="addingQuote"></mat-spinner>
    </li>
  </ul>
  <table class="table table--full-width" *ngIf="quotes.length > 0 && getRecommendationIds().length > 0" style="margin-top: 2%;" >
    <thead>
      <tr>
        <th>{{'Component Actions' | translate | async}}</th>
        <th>{{'Side' | translate | async}}</th>
        <th>{{'Pos.' | translate | async}}</th>
        <th>{{'Recommendation' | translate | async}}</th>
        <th class="right-align">{{'Labour' | translate | async}}</th>
        <th class="right-align">{{'Parts' | translate | async}}</th>
        <th class="right-align">{{'Misc' | translate | async}}</th>
        <th class="right-align">{{'Total' | translate | async}}</th>
        <th class="right-align">{{'Action Date' | translate | async}}</th>
        <th class="right-align">{{'Action SMU' | translate | async}}</th>
        <th class="right-align">{{'Severity' | translate | async}}</th>
        <th class="right-align">{{'Hours Gained' | translate | async}}</th>
        <th style="padding: 8px 16px;">{{'Comment' | translate | async}}</th>
         <th style="padding: 8px 16px;">{{'Status' | translate | async}}</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <!-- <quote-row *ngFor="let quoteDetail of quotes.Recommendations" [quoteDetail]="quoteDetail" [recommendationId]="quoteDetail.RecommendationId" [quoteId]="selectedQuoteId" [inspectionId]="inspectionId" (update)="UpdateRecom($event)" ></quote-row> -->
      <!-- <quote-row *ngFor="let quoteDetail of getRecommendationIds()" [recommendationId]="quoteDetail" [quoteId]="selectedQuoteId" [inspectionId]="inspectionId" (update)="UpdateRecom($event)" ></quote-row> -->
      <quote-row *ngFor="let quoteDetail of getRecommendationList()" [quoteDetail]="quoteDetail" [recommendationId]="quoteDetail.RecommendationId" [quoteId]="selectedQuoteId" [inspectionId]="inspectionId" (update)="UpdateRecom($event)" ></quote-row>
    </tbody>
  </table>
  <div style="margin-top: 12px;" *ngIf="!(quotes.length > 0)">{{'There are currently no quotes.' | translate | async}}<span *ngIf="isInterpreter"> Click the + to create one now. </span></div>
  <div style="margin-top: 12px;" *ngIf="!(getRecommendationIds().length > 0) && quotes.length > 0">{{'There are currently no recommendations added for this quote.' | translate | async}}</div>
</div>
